import { render, staticRenderFns } from "./kdxHeaderBar.g.vue?vue&type=template&id=4930ab00&scoped=true"
import script from "./kdxHeaderBar.g.vue?vue&type=script&lang=js"
export * from "./kdxHeaderBar.g.vue?vue&type=script&lang=js"
import style0 from "./kdxHeaderBar.g.vue?vue&type=style&index=0&id=4930ab00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4930ab00",
  null
  
)

export default component.exports